import styled from "styled-components";

export const StyledDialItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
  position: relative;
`;

export const StyledDialDetails = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 8px;
`;

export const StyledDialerPercentageWrapper = styled.div`
  display: flex;
  gap: 4px;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(0%, -50%);
`;

export const StyledDialerPercentage = styled.div`
  background-color: ${(p) => p.theme.paperBg};
  border: 1px solid ${(p) => p.theme.border};
  padding: 0 4px;
  border-radius: 4px;
`;
